import { Tooltip, Popconfirm, Button } from 'antd';
import type { ButtonProps } from 'antd';
import { SaveOutlined, CloseOutlined } from '@ant-design/icons';

const SaveCancelTooltip = ({ onSave, onCancel }) => {
  return (
    <>
      <Tooltip title="Save">
        <Button
          icon={<SaveOutlined />}
          onClick={onSave}
          style={{ marginRight: 8 }}
          type="primary"
          data-testid="row-save-button"
        />
      </Tooltip>
      <Popconfirm
        title="Cancel changes?"
        onConfirm={onCancel}
        okButtonProps={{ 'data-testid': 'popconfirm-ok-button' } as ButtonProps}
        cancelButtonProps={{ 'data-testid': 'popconfirm-cancel-button' } as ButtonProps}
      >
        <Tooltip title="Cancel">
          <Button icon={<CloseOutlined />} data-testid="row-cancel-button" />
        </Tooltip>
      </Popconfirm>
    </>
  );
};

export default SaveCancelTooltip;
